/* WT-Direct Brutto-/Netto-Umschalter – reine Preisanzeige, Checkout bleibt unverändert */
(function () {
  if (window.__wtdPriceToggle) return;
  window.__wtdPriceToggle = true;

  var STORAGE_KEY = 'wtd_price_display_v1';
  var VAT_FACTOR = 1.19;
  var PRICE_SELECTOR = '.price, .s1pr, #cart-total, #cart-total--m, [data-wtd-money]';
  var stateByElement = new WeakMap();
  var observerScheduled = false;
  var mode = readMode();

  function readMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'net' ? 'net' : 'gross';
    } catch (error) {
      return 'gross';
    }
  }

  function saveMode(nextMode) {
    try {
      localStorage.setItem(STORAGE_KEY, nextMode);
    } catch (error) {}
  }

  function parseLocalizedNumber(value) {
    var normalized = value.replace(/[\s ']/g, '');
    var comma = normalized.lastIndexOf(',');
    var dot = normalized.lastIndexOf('.');
    var decimal = '';

    if (comma > -1 && dot > -1) {
      decimal = comma > dot ? ',' : '.';
    } else if (comma > -1 && normalized.length - comma - 1 === 2) {
      decimal = ',';
    } else if (dot > -1 && normalized.length - dot - 1 === 2) {
      decimal = '.';
    }

    if (decimal) {
      var thousands = decimal === ',' ? /\./g : /,/g;
      normalized = normalized.replace(thousands, '').replace(decimal, '.');
    } else {
      normalized = normalized.replace(/[.,]/g, '');
    }

    return Number(normalized);
  }

  function formatNetNumber(value) {
    var locale = document.documentElement.lang || 'de-DE';
    try {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return value.toFixed(2).replace('.', ',');
    }
  }

  function convertMoneyToken(token) {
    var numberMatch = token.match(/-?\d(?:[\d\s .,']*\d)?/);
    if (!numberMatch) return token;

    var grossValue = parseLocalizedNumber(numberMatch[0]);
    if (!Number.isFinite(grossValue)) return token;

    return token.replace(numberMatch[0], formatNetNumber(grossValue / VAT_FACTOR));
  }

  function convertText(text) {
    var currency = '(?:€|\\$|£|CHF|EUR|USD|GBP|SEK|NOK|DKK|PLN|CZK)';
    var amount = "-?\\d(?:[\\d\\s\\u00a0.,']*\\d)?";
    var pattern = new RegExp(currency + '\\s*' + amount + '|' + amount + '\\s*' + currency, 'g');
    return text.replace(pattern, convertMoneyToken);
  }

  function convertHtml(html) {
    var template = document.createElement('template');
    template.innerHTML = html;

    function walk(node) {
      var child = node.firstChild;
      while (child) {
        var next = child.nextSibling;
        if (child.nodeType === 3) {
          child.nodeValue = convertText(child.nodeValue || '');
        } else if (child.nodeType === 1 && !child.matches('.wtd-tax-note, .wtd-cart-tax-status, .wtd-net-price')) {
          walk(child);
        }
        child = next;
      }
    }

    walk(template.content);
    return template.innerHTML;
  }

  function isEligiblePriceElement(element) {
    if (!element || element.closest('.wtd-price-toggle')) return false;
    if (/^\/account(?:\/|$)/.test(window.location.pathname) && element.closest('#content')) return false;
    if ((element.textContent || '').indexOf('Preis auf Anfrage') > -1) return false;
    return /(?:€|\$|£|CHF|EUR|USD|GBP|SEK|NOK|DKK|PLN|CZK)/.test(element.textContent || '');
  }

  function getPriceElements() {
    var elements = Array.prototype.slice.call(document.querySelectorAll(PRICE_SELECTOR));
    return elements.filter(function (element) {
      if (!isEligiblePriceElement(element)) return false;
      var parentMatch = element.parentElement && element.parentElement.closest(PRICE_SELECTOR);
      return !parentMatch;
    });
  }

  function renderPrice(element) {
    var currentHtml = element.innerHTML;
    var state = stateByElement.get(element);

    if (mode === 'net') {
      if (state && state.net === currentHtml) return;
      state = {
        gross: currentHtml,
        net: convertHtml(currentHtml)
      };
      stateByElement.set(element, state);
      if (state.net !== currentHtml) element.innerHTML = state.net;
      return;
    }

    if (state && state.net === currentHtml) {
      element.innerHTML = state.gross;
      return;
    }

    stateByElement.set(element, {
      gross: currentHtml,
      net: null
    });
  }

  function ensureTaxNotes() {
    var prices = document.querySelectorAll('.product-card .price, .f8pr-price.price');

    Array.prototype.forEach.call(prices, function (price) {
      if (!isEligiblePriceElement(price)) return;
      var next = price.nextElementSibling;
      if (next && next.classList.contains('wtd-tax-note')) return;

      var note = document.createElement('span');
      note.className = 'wtd-tax-note';
      note.setAttribute('data-wtd-tax-label', '');
      price.insertAdjacentElement('afterend', note);
    });
  }

  function ensureCartStatus() {
    var totals = document.querySelectorAll('.form-cart .s1pr, #cart .s1pr');

    Array.prototype.forEach.call(totals, function (total) {
      if (!isEligiblePriceElement(total)) return;
      var next = total.nextElementSibling;
      if (next && next.classList.contains('wtd-cart-tax-status')) return;

      var status = document.createElement('span');
      status.className = 'wtd-cart-tax-status';
      status.setAttribute('data-wtd-cart-tax-label', '');
      total.insertAdjacentElement('afterend', status);
    });
  }

  function syncLabels() {
    var taxLabel = mode === 'net' ? 'zzgl. 19 % MwSt.' : 'inkl. MwSt.';
    var cartLabel = mode === 'net'
      ? 'Netto-Anzeige; die MwSt. wird im Checkout ausgewiesen.'
      : 'Brutto-Anzeige inklusive MwSt.';

    Array.prototype.forEach.call(document.querySelectorAll('[data-wtd-tax-label]'), function (label) {
      if (label.textContent !== taxLabel) label.textContent = taxLabel;
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-wtd-cart-tax-label]'), function (label) {
      if (label.textContent !== cartLabel) label.textContent = cartLabel;
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-wtd-footer-tax]'), function (label) {
      var footerLabel = mode === 'net'
        ? '* Angezeigte Preise netto, zzgl. gesetzlicher USt.'
        : '* Alle Preise inkl. gesetzlicher USt.';
      if (label.textContent !== footerLabel) label.textContent = footerLabel;
    });
  }

  function syncButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wtd-price-mode]'), function (button) {
      var active = button.getAttribute('data-wtd-price-mode') === mode;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderAll() {
    document.documentElement.setAttribute('data-wtd-price-mode', mode);
    getPriceElements().forEach(renderPrice);
    ensureTaxNotes();
    ensureCartStatus();
    syncLabels();
    syncButtons();
  }

  function setMode(nextMode) {
    mode = nextMode === 'net' ? 'net' : 'gross';
    saveMode(mode);
    renderAll();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || target.nodeType !== 1 || !target.closest) return;
    var button = target.closest('button[data-wtd-price-mode]');
    if (!button) return;
    event.preventDefault();
    setMode(button.getAttribute('data-wtd-price-mode'));
  });

  function scheduleRender() {
    if (observerScheduled) return;
    observerScheduled = true;
    window.requestAnimationFrame(function () {
      observerScheduled = false;
      renderAll();
    });
  }

  function nodeContainsPrice(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(PRICE_SELECTOR)) return true;
    return Boolean(node.querySelector && node.querySelector(PRICE_SELECTOR));
  }

  function mutationsContainPriceChange(mutations) {
    for (var index = 0; index < mutations.length; index += 1) {
      var mutation = mutations[index];
      var target = mutation.target && mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target && mutation.target.parentElement;

      if (target && (
        target.matches(PRICE_SELECTOR)
        || target.closest(PRICE_SELECTOR)
      )) {
        return true;
      }

      for (var childIndex = 0; childIndex < mutation.addedNodes.length; childIndex += 1) {
        if (nodeContainsPrice(mutation.addedNodes[childIndex])) return true;
      }
    }

    return false;
  }

  function boot() {
    renderAll();
    try {
      var observer = new MutationObserver(function (mutations) {
        if (mutationsContainPriceChange(mutations)) scheduleRender();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (error) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
